import React from "react";
import { MessageCircle, Search, PenTool, Rocket } from "lucide-react";
import { useReveal } from "../hooks/useReveal";

const steps = [
  {
    n: "01",
    icon: MessageCircle,
    title: "Kontakt",
    desc: "Piszesz lub dzwonisz. Pierwsza odpowiedź zwykle w 1 godzinę.",
  },
  {
    n: "02",
    icon: Search,
    title: "Analiza",
    desc: "Rozmawiamy o Twojej firmie, klientach i celach. Zero szablonów.",
  },
  {
    n: "03",
    icon: PenTool,
    title: "Projekt i realizacja",
    desc: "Designujemy, kodujemy, optymalizujemy. Cały czas w kontakcie.",
  },
  {
    n: "04",
    icon: Rocket,
    title: "Gotowa strona",
    desc: "Wdrożenie, szkolenie z panelu i wsparcie po starcie. Działamy.",
  },
];

export const Process = () => {
  const ref = useReveal();
  return (
    <section
      id="proces"
      ref={ref}
      data-testid="process-section"
      className="relative py-24 md:py-32 px-6 md:px-10 bg-[#16162a]"
    >
      <div className="max-w-7xl mx-auto">
        <div className="reveal max-w-3xl mb-14">
          <span className="text-xs tracking-[0.2em] uppercase text-stormly-cyan font-bold">
            Proces
          </span>
          <h2 className="font-heading font-bold text-4xl sm:text-5xl md:text-6xl mt-4 leading-[1.05]">
            Cztery kroki.{" "}
            <span className="text-white/50">Zero komplikacji.</span>
          </h2>
        </div>

        <div className="relative">
          {/* connector line */}
          <div className="hidden lg:block absolute top-[88px] left-0 right-0 h-px bg-gradient-to-r from-transparent via-stormly-cyan/30 to-transparent" />

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {steps.map((s, i) => {
              const Icon = s.icon;
              return (
                <div
                  key={s.n}
                  data-testid={`process-step-${i}`}
                  className={`reveal reveal-delay-${i + 1} relative group`}
                >
                  <div className="relative bg-[#1F1F38] border border-white/10 rounded-3xl p-7 hover:border-stormly-cyan/40 transition-colors duration-500">
                    <div className="flex items-start justify-between mb-8">
                      <span className="step-num text-5xl font-black leading-none">
                        {s.n}
                      </span>
                      <div className="h-11 w-11 rounded-2xl bg-stormly-cyan/10 border border-stormly-cyan/30 flex items-center justify-center group-hover:bg-stormly-cyan/20 transition-colors">
                        <Icon size={18} className="text-stormly-cyan" />
                      </div>
                    </div>
                    <h3 className="font-heading text-xl font-bold mb-2">
                      {s.title}
                    </h3>
                    <p className="text-white/60 text-sm leading-relaxed">
                      {s.desc}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
